import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';

/**
 * Updates the snapshot
 * @cancelCurrentPeriod whether to cancel the current period
 * @cancelFuturePeriod whether to cancel the future period
 * @returns Data object indicating success
 */
export function putSnapshot(
  this: unknown,
  cancelCurrentPeriod: boolean,
  cancelFuturePeriod: boolean
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(mapManagementServiceEnvironment.resolve(this).snapshotUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({
          cancelCurrentPeriod,
          cancelFuturePeriod,
        }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
      })
    )
  );
}
